import { ImageState } from 'editor/src/store/gallery/types';
import { RootState } from 'editor/src/store/index';

import getGalleryImages from './getGalleryImages';

const isAnyImageFailed = (state: RootState) =>
  !!getGalleryImages(state).find((image) => image.state === ImageState.FAILED);

export default isAnyImageFailed;
